import React from 'react';

import ReactSwitch from 'react-switch';
import { Config } from '../../helpers/config';

type SwitchProps = {
  isChecked?: boolean;
  onChange?: (val: boolean) => void;
  disabled?: boolean;
};

export const Switch: React.FC<SwitchProps> = ({
  isChecked = false,
  onChange = () => {},
  disabled = false,
}) => {
  return (
    <ReactSwitch
      onChange={onChange}
      disabled={disabled}
      checked={isChecked}
      checkedIcon={false}
      uncheckedIcon={false}
      onColor={Config.primaryBlue}
      offColor={'#ECECEC'}
    />
  );
};
